import React, { useContext, createContext } from 'react';

import { SliderLayoutProps } from '../@types/SliderLayoutProps';

export const SliderLayoutContext = createContext<SliderLayoutProps>({} as SliderLayoutProps);

SliderLayoutContext.displayName = 'SliderLayout';

const SliderLayoutProvider = (props: SliderLayoutProps) => {
	return <SliderLayoutContext.Provider value={props}>{props.children}</SliderLayoutContext.Provider>;
};

export const useSliderLayout = () => {
	const context = useContext(SliderLayoutContext);

	return context;
};

export default SliderLayoutProvider;
